import React from 'react'

export default function Video({value, onDataChanged, props}) {
    return <div>
        <hr/>
        <h5 className="hotspot-setting-header">Video Url</h5>
        <div className="hotspot-setting-info">
            This is the url to the youtube video, which will be shown on the hotspots position.
        </div>
        <div className="form-group">
            <input
                className="form-control"
                type="text"
                placeholder="https://youtube.com/..."
                value={value}
                onChange={onDataChanged}
            />
        </div>
    </div>
}
